// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__P4-Dc"};